<!-- eslint-disable vue/no-template-shadow -->
<template>
  <div v-if="!isLoading">
    <!-- MOSTRAR DELETE -->
    <v-dialog
      v-model="isDialogVisibleDelete"
      scrollable
      max-width="350px"
    >
      <v-card max-height="400px">
        <v-card-title>{{ `${$t('btn.delete')} ${itemDelete.name}` }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>{{ $t('msg.deleteItem', { item: itemDelete.name }) }}</v-card-text>
        <v-card-text>{{ $t('msg.deleteToken') }}</v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="primary"
            outlined
            @click="isDialogVisibleDelete = !isDialogVisibleDelete"
          >
            {{ $t('btn.close') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            :loading="loading"
            @click="confirmDelete()"
          >
            {{ $t('btn.send') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-text>
      <v-row>
        <!--MANGER-DATABASE-->
        <template
          v-if="permisos.includes('app_backoffice:list') || permisos.includes('*')"
        >
          <APPData
            :apps="apps"
            :user="user"
            type_app="manager_database"
          />
        </template>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import {
  mdiMagnify,
  mdiDeleteOutline,
  mdiSquareEditOutline,
  mdiPlus,
  mdiArrowLeft,
  mdiUpdate,
  mdiFormatListText,
  mdiKeyChain,
  mdiLinkVariant,
  mdiLink,
} from '@mdi/js'
import APPData from '../utils/APPData.vue'

export default {
  components: {
    APPData,
  },
  data() {
    return {
      pos: 0,
      url_doc: process.env.VUE_APP_DOC_URL,
      isLoading: true,
      generando: false,
      search: '',
      items: [],
      onlyInactivo: false,
      icons: {
        mdiMagnify,
        mdiDeleteOutline,
        mdiSquareEditOutline,
        mdiPlus,
        mdiArrowLeft,
        mdiUpdate,
        mdiFormatListText,
        mdiKeyChain,
        mdiLinkVariant,
        mdiLink,
      },
      isDialogVisible: false,
      isLoad: true,
      permisos: sessionStorage.getItem('permisos_auth'),
      itemDelete: {},
      itemRegenerate: {},
      isDialogVisibleDelete: false,
      companies: [],
      visibleCreateApiKey: false,
      apikey: {},
      loading: false,
      itemEdicActive: {},
      tokensEdicActive: {},
      showEditTokenDialog: false,
      showEditTokenDialogPropio: false,
      showEditTokenActiveDialog: false,
      showEditTokenActiveDialogPropio: false,
      user: {},
      offline: false,
      apps: [],
    }
  },
  mounted() {
    this.profile()

    // this.getCompanies()
    // this.load()
  },
  created() {
    this.getAPPS()
  },
  methods: {
    profile() {
      this.axios
        .get(`${process.env.VUE_APP_API_URL}profile`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(response => {
          this.user = response.data.data
          if (this.user.company_id) {
            if (this.user.company) {
              if (this.user.company.offline) {
                this.offline = this.user.company.offline
              }
            }
          }
        })
        .catch(error => console.log(error))
        // eslint-disable-next-line no-return-assign
        .finally(() => (this.isLoading = false))
    },
    getCompanies() {
      this.axios
        .get('api_keys/companies', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(response => {
          this.companies = response.data.data

          // console.log(this.companies)
        })
        .catch(error => console.log(error))
    },
    getAPPS() {
      this.axios
        .post(
          'apps',
          { type: 'manager_database' },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(response => {
          const result = response.data.data
          result.forEach(element => {
            if (element.slug === 'backoffice' && this.permisos.includes('app_backoffice:list')) {
              this.apps.push(element)
            }
          })
        })
        .catch(error => console.log(error))
    },
    load() {
      this.axios
        .get('api_keys', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            if (res.data.data.status === 401) {
              // this.$toast.error(this.$t('msg.noAutorice'))
              // this.$store.commit('logout')
            }
          } else {
            this.items = res.data.data
            this.onlyInactivo = res.data.inactivos
          }
        })
    },
    openGenerateApiKey() {
      if (this.item.api_key) {
        this.isDialogVisible = true
      } else {
        this.generateApiKey()
      }
    },
    generateApiKey() {
      this.generando = true
      this.axios
        .post('api_keys/generate', this.itemRegenerate, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            if (res.data.data.status === 401) {
              // this.$toast.error(this.$t('msg.noAutorice'))
              // this.$store.commit('logout')
            } else if (res.data.data.status === 412) {
              this.$toast.error(this.$t('msg.noAsociedCompany'))
            }
          } else {
            this.load()
            this.$toast.success(this.$t('msg.successToken'))
          }
        })
        .finally(() => {
          this.generando = false
          this.isDialogVisible = false
        })
    },
    copyToClipboard(id) {
      const copyText = document.getElementById(id).textContent
      navigator.clipboard.writeText(copyText)

      // document.execCommand('copy')
      this.$toast.info(this.$t('msg.copyText', { text: copyText }))

      // this.$toast.info(this.$t('msg.copyText', { text: id }))
    },
    showModal(item) {
      this.item = item
      this.isLoad = true
      if (item.permisos !== null) {
        this.abilities = item.permisos.abilities
      } else {
        this.abilities = []
      }
      this.loadPermisos()
      this.isDialogVisible = !this.isDialogVisible
    },
    loadPermisos() {
      this.abilityList = []
      this.axios
        .get('permiso?per_page=1000', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          const items = res.data.data
          // eslint-disable-next-line no-plusplus
          for (let indexA = 0; indexA < this.abilities.length; indexA++) {
            const ability = this.abilities[indexA]
            if (ability === '*') {
              // eslint-disable-next-line no-plusplus
              for (let index = 0; index < items.length; index++) {
                const element = items[index]
                this.abilityList.push(element.name)
              }
            } else {
              // eslint-disable-next-line no-plusplus
              for (let index = 0; index < items.length; index++) {
                const element = items[index]
                if (element.ability === ability) {
                  this.abilityList.push(element.name)
                }
              }
            }
          }
          // eslint-disable-next-line no-return-assign
        })
        // eslint-disable-next-line no-return-assign
        .finally(() => (this.isLoad = false))
    },
    closeDialog() {
      this.isDialogVisible = !this.isDialogVisible
    },
    closeDialogDelete() {
      this.isDialogVisibleDelete = !this.isDialogVisibleDelete
      this.itemDelete = {}
    },
    newItem() {
      sessionStorage.removeItem('api_keys-id')
      this.$router.push({ name: 'api_keys-update' })
    },
    editItem(iten) {
      this.itemRegenerate = iten
      this.isDialogVisible = true
    },
    editActive(iten) {
      this.axios
        .post(
          `api_keys/active/${iten.id}`,
          { active: iten.active },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(res => {
          if (res.data.success === false) {
            // this.$toast.error(this.$t('msg.noAutorice'))
            // this.$store.commit('logout')
          }
        })
    },
    deleteItem(iten) {
      this.isDialogVisibleDelete = true
      this.itemDelete = iten
    },
    confirmDelete() {
      this.loading = true
      this.axios
        .post('api_keys/delete-token', this.itemDelete, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            // this.$toast.error(this.$t('msg.noAutorice'))
            // this.$store.commit('logout')
          } else {
            this.load()
          }
        })
        .finally(() => this.closeDialogDelete())
    },

    save() {
      if (this.apikey.name) {
        this.loading = true

        this.axios
          .post(
            'api_keys/crear',
            { name: this.apikey.name },
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
              },
            },
          )
          .then(res => {
            if (res.data.success === false) {
              if (res.data.data.status === 401) {
                // this.$toast.error(this.$t('msg.noAutorice'))
                // this.$store.commit('logout')
              } else if (res.data.data.status === 412) {
                this.$toast.error(this.$t('msg.noAsociedCompany'))
              }
            } else {
              this.load()
              this.$toast.success(this.$t('msg.successToken'))
            }
          })
          .finally(() => {
            this.loading = false
            this.visibleCreateApiKey = false
            this.apikey = {}
          })
      } else {
        this.$toast.error(this.$t('msg.datasRequiere'))
      }
    },
    editActiveTokenPropio(iten) {
      this.tokensEdicActive = iten
      if (!iten.active) {
        // this.confirmDesactive()
        this.showEditTokenDialogPropio = true
      } else {
        this.showEditTokenActiveDialogPropio = true
      }
    },
    editActiveToken(iten, token) {
      this.itemEdicActive = iten
      this.tokensEdicActive = token
      if (token.active) {
        // this.confirmDesactive()
        this.showEditTokenActiveDialog = true
      } else {
        this.showEditTokenDialog = true
      }

      // console.log(this.itemEdicActive)
      // console.log(this.tokensEdicActive)
    },
    confirmDesactive() {
      this.loading = true
      this.axios
        .post(`api_keys/edit-token/${this.itemEdicActive.id}`, this.tokensEdicActive, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            // this.$toast.error(this.$t('msg.noAutorice'))
            // this.$store.commit('logout')
          } else {
            this.getCompanies()
          }
        })
        .finally(() => this.closeDialogDesactive())
    },
    confirmDesactivePropio() {
      this.loading = true
      this.axios
        .post(`api_keys/edit-token/${this.tokensEdicActive.company_id}`, this.tokensEdicActive, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            // this.$toast.error(this.$t('msg.noAutorice'))
            // this.$store.commit('logout')
          } else {
            this.load()
          }
        })
        .finally(() => this.closeDialogDesactive())
    },
    cancelDesactive() {
      this.closeDialogDesactive()
      this.getCompanies()
    },
    cancelDesactivePropio() {
      this.closeDialogDesactive()
      this.load()
    },
    closeDialogDesactive() {
      this.loading = false
      this.showEditTokenDialogPropio = false
      this.showEditTokenDialog = false
      this.showEditTokenActiveDialog = false
      this.showEditTokenActiveDialogPropio = false
      this.itemEdicActive = {}
      this.tokensEdicActive = {}
    },

    goDoc(item) {
      // eslint-disable-next-line camelcase
      const { api_key } = item
      // eslint-disable-next-line camelcase
      const { secret_token } = item

      // eslint-disable-next-line camelcase
      const url = `${this.url_doc}login?api_key=${api_key}&secret_token=${secret_token}`

      /* const route = this.$router.resolve({
        name: 'UserProfileView',
        params: {id: participantUser.user_id},
      }) */
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.table-kitchen-sink ::v-deep {
  .v-data-table-header {
    white-space: nowrap;
  }
}
</style>
